import {
  OptionResourceResponseData,
  ResourceData,
  PurposesOfEnquiryResponseData,
  DepositSourcesResponseData,
} from './types';
import { Option, OptionWithName } from 'shared/interface/globalInterface';

export const responseResourceToResourceData = (optionResources: OptionResourceResponseData[]): ResourceData => {
  return optionResources.map((item) => ({
    label: item.option,
    value: item.value,
  }));
};

export const purposesOfEnquiryToResourceData = (resources: PurposesOfEnquiryResponseData[]): ResourceData => {
  return resources.map((item) => ({
    label: item.value,
    value: item.value,
  }));
};

export const clubsToResourceData = (submission_routes: OptionWithName[]): ResourceData => {
  return submission_routes.map((submission_route) => ({
    label: submission_route.name,
    value: submission_route.id.toString(),
  }));
};

export const mapOptions = (data: Option[] = []) => {
  return data.map((item) => ({ option: item.value, value: item.option }));
};

export const productSelectionLoanPurposesToResourceData = (
  loanPurposes: Array<{ option: string; value: string }>,
): ResourceData => {
  return loanPurposes.map((item) => ({
    label: item.option,
    value: item.value,
  }));
};

export const depositSourcesToResourceData = (depositSources: DepositSourcesResponseData[]): ResourceData => {
  return depositSources.map((item) => ({
    label: item.option,
    value: item.value,
  }));
};
